import React from 'react';

const Applications = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="12" fill="#ffc844" />
    <path
      d="M8.1 17.9C8.1 19 7.2 20 6 20c-1.1 0-2-.9-2-2.1 0-1.1.9-2.1 2.1-2.1 1.1.1 2 1 2 2.1zm6 0c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.1.1 2.1 1 2.1 2.1zm5.9 0c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.2.1 2.1 1 2.1 2.1zM8.1 12c0 1.1-.9 2.1-2.1 2.1-1.1 0-2-1-2-2.1s.9-2.1 2.1-2.1c1.1 0 2 1 2 2.1zm6 0c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.1 0 2.1 1 2.1 2.1zm5.9 0c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1zM8.1 6.1c0 1.1-.9 2.1-2.1 2.1-1.1-.1-2-1-2-2.1C4 4.9 4.9 4 6.1 4c1.1 0 2 .9 2 2.1zm6 0c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.2 1-2.1 2.1-2.1s2.1.9 2.1 2.1zm5.9 0c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.2 0 2.1.9 2.1 2.1zm0 0"
      fill="#fff"
    />
  </svg>
);

const Dashboard = (
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <path
      fill="#009eb0"
      d="M78.2 183.9c0 3.7 3 6.7 6.7 6.7h131.3c3.7 0 6.7-3 6.7-6.7V96.2H78.2v87.7zm104.4-69c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8c.1-14.7 12.1-26.8 26.8-26.8zM90.2 123h13.4v40.8h6.7v-27.5h13.4v27.5h6.7v-54.2h13.4v67.6H90.2V123z"
    />
    <path
      fill="#009eb0"
      d="M182.6 155.1c7.4 0 13.4-6 13.4-13.4h-13.4v-13.4c-7.4 0-13.4 6-13.4 13.4.1 7.4 6.1 13.4 13.4 13.4z"
    />
    <path
      fill="#009eb0"
      d="M150.5.5C67.7.5.5 67.7.5 150.5s67.2 150 150 150 150-67.2 150-150S233.3.5 150.5.5zm85.7 183.4c0 11.1-9 20.1-20.1 20.1h-58.9v23.1H184v13.4h-67v-13.4h26.8V204H84.9c-11.1 0-20.1-9-20.1-20.1V82.8h79V69.1h13.4v13.7h79v101.1z"
    />
  </svg>
);

const Facebook = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <path fill="none" d="M0 0h300v300H0z" />
    <path
      d="M72 110h45.8C117.4 79.3 100-12.4 216.2 1.4c2.7.2 6.6.6 11.8 1.2v47.6h-29.5c-9.6-.4-16.4 2.1-20.1 7.1-3.8 5-5.6 12.3-5.6 21.9v30.6h53l-6.6 53.4h-46.4l.4 136.4h-54.9V163.4H72V110z"
      fill="#fff"
    />
  </svg>
);

const LeadManagement = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path
      d="M7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm.1 3c.5 0 .5.5.5.5s0 .5-.5.5C5 3.9 3.9 5.5 3.9 5.5S4.6 2.9 7.1 3zM3.3 6.7c0-.5.5-.5.5-.5s.5 0 .5.5c-.2 2.1 1.5 3.2 1.5 3.2s-2.6-.7-2.5-3.2zm3.7 4c-.5 0-.5-.5-.5-.5s-.1-.5.4-.5C9 9.7 10 8 10 8s-.5 2.7-3 2.7zm3.4-3.3s-.6.1-.5-.4c0-2.1-1.6-3.2-1.6-3.2s2.7.6 2.6 3.1c0 .5-.5.5-.5.5z"
      fill="#5ab3e8"
    />
  </svg>
);

const Linkedin = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <path fill="none" d="M0 0h300v300H0z" />
    <path
      d="M269.5 263.7h-48.7v-76.3c0-18.3-.3-41.6-25.3-41.6-25.4 0-29.3 19.9-29.3 40.3v77.6h-48.7v-157h46.8v21.5h.7c6.5-12.4 22.5-25.3 46.1-25.3 49.4 0 58.5 32.4 58.5 74.8v86zM62.5 85.4c-15.6 0-28.4-12.7-28.4-28.4s12.7-28.2 28.4-28.2S90.7 41.5 90.7 57c0 15.6-12.6 28.4-28.2 28.4zM38 263.7h48.7v-157H38v157z"
      fill="#fffffe"
    />
  </svg>
);

const Mobile = (
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <circle fill="#ffa043" cx="7.1" cy="9.5" r=".5" />
    <path fill="#ffa043" d="M8 3.6s.1 0 0 0c.1-.2 0-.2 0-.2H6.2c-.1.1 0 .2 0 .2H8zm-2.7.3H9v4.7H5.3z" />
    <path
      fill="#ffa043"
      d="M7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm2.5 9.8c0 .3-.3.6-.6.6H5.3c-.3 0-.6-.3-.6-.6V3.6c0-.3.2-.6.6-.6h3.6c.3 0 .6.3.6.6v6.2z"
    />
  </svg>
);

const Nativious = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <g fill="none" strokeWidth="12" strokeMiterlimit="10">
      <circle cx="158.3" cy="169.6" r="123.4" opacity=".8" stroke="#544989" />
      <circle cx="169.3" cy="143.4" r="123.4" opacity=".8" stroke="#4994ac" />
      <circle cx="142.5" cy="130.6" r="123.4" opacity=".8" stroke="#175f8f" />
      <circle cx="130.3" cy="159.2" r="123.4" opacity=".8" stroke="#874c8c" />
    </g>
    <path
      d="M96.4 176.5s4.2-55.7 10.6-74 25.5-7.2 23.1 9.8c-2.4 17-10.1 51.1 7.6 10.5s46.9-37.9 36.9 7.8c-10 45.7-6.7 60 28.6 34.1 9.5-6.2 27.7.6 8.8 19.3-8.2 9.4-49.8 29.2-58.4 10.9s7-83.9-6.5-49.4c-13.4 34.6-48.5 96.4-50.7 31z"
      fill="#333"
    />
  </svg>
);

const PerformanceAdvertiser = (
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path fill="#ec0b43" d="M3.7 6.2c0 .3.2.6.5.6V5.6c-.4.1-.5.3-.5.6z" />
    <path
      fill="#ec0b43"
      d="M7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zM4.1 7.4c-.5-.1-.9-.6-.9-1.2s.4-1 .9-1.1c.1-.3.3-.5.6-.5h1.1v3.3h-1c-.3-.1-.6-.3-.7-.5zm1.5 2.7c-.3 0-.6-.2-.6-.5l-.2-1.3h.3c.3 0 .7 0 1 .1l.2 1c.1.3-.2.7-.7.7zm3.2-1.5c-.8-.3-1.3-.5-2.4-.7V4.6c1.1-.2 1.6-.4 2.4-.7v4.7zm1.4.2c0 .3-.2.5-.5.5s-.4-.3-.4-.5v-5c0-.3.2-.5.5-.5s.5.2.5.5v5z"
    />
  </svg>
);

const PerformanceEMailing = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path
      d="M7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zM3.2 5.9c.1.1.3.2.4.4.6.4 1.1.7 1.5 1L3.2 9.2V5.9zm6.9 4H3.9c-.2 0-.3-.1-.4-.2l2.2-2.2c.1 0 .1.1.1.1.1.2.2.3.3.4.1.1.2.1.4.2s.4.1.5.1c.1 0 .3 0 .5-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3l.1-.1 2.2 2.2c-.2.1-.3.1-.5.1zm.7-.7L8.9 7.3c.4-.3.9-.6 1.5-1 .2-.1.3-.2.4-.4v3.3zm-.2-3.9c-.1.2-.3.4-.5.5-.7.5-1.2.8-1.6 1.1-.2.1-.3.2-.4.3H8s-.1 0-.1.1c-.1.1-.2.1-.2.2-.1 0-.1.1-.2.1-.1.1-.2.1-.3.1h-.4c-.1 0-.2 0-.3-.1 0 0-.1-.1-.2-.1s-.1-.1-.2-.2c-.1 0-.1 0-.1-.1h-.1c-.1-.1-.3-.2-.4-.3-.2-.2-.4-.3-.7-.5-.5-.3-.8-.5-.9-.6-.2-.1-.3-.3-.5-.5-.1-.2-.2-.4-.2-.6 0-.2.1-.4.2-.6.1-.1.3-.1.5-.1h6.3c.2 0 .3.1.5.2.1.1.2.3.2.5l-.3.6z"
      fill="#ec0b43"
    />
  </svg>
);

const PerformancePublisher = (
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path fill="#ec0b43" d="M8 9.7l-.1.5.1.1.5-.1-.1-.4z" />
    <path
      fill="#ec0b43"
      d="M7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm.1 10.2H4.5c-.4 0-.8-.4-.8-.8V4.5c0-.4.4-.8.8-.8h4.9c.4 0 .8.4.8.8V7H10c-.1 0-.2 0-.3.1V4.8H4.2v4.6c0 .1.1.3.3.3h2.7l-.1.5zm-1-2.7v-.6h2.7v.5H6.1zm2.5.5l-.5.6h-2V8h2.5zM6.1 6.4v-.5h2.7v.5H6.1zm-1 1.1v-.6h.5v.5h-.5zm.5.5v.5h-.5V8h.5zm-.5-1.6v-.5h.5v.5h-.5zm3.6 4l-1 .3h-.1v-.1l.3-1v-.1l1.3-1.3.8.8-1.3 1.4zm1.9-2l-.3.3-.8-.8.3-.3c.1-.1.3-.1.4 0l.4.4c.1.1.1.3 0 .4z"
    />
  </svg>
);

const Performance = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path
      d="M7 0C3.2 0 0 3.2 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zM4 7.5s3.1-.4 4.7-4h-.2l.7-1 .1 1.2-.4-.2C7.3 7.3 4 7.8 4 7.8v-.3zm5.6-2.3v4.4H8.4V5.2h1.2zM8.1 6.8v2.8H6.9V6.8h1.2zm-1.6 1v1.8H5.3V7.8h1.2zM5 8.2v1.4H3.8V8.2H5zm4.9 2.5v-.3H3.3V4.2H3L3.4 3l.4 1.1h-.3V10l6.5.1v-.3l1.1.4-1.2.5z"
      fill="#ec0b43"
    />
  </svg>
);

const TimeoneComplet = (
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155 55">
    <path
      fill="#303747"
      d="M3.7 40.4h5.2v.8H4.6v2.4h3.9v.8H4.6v2.5H9v.8H3.7zm8.5 0h.7l4.6 5.8v-5.8h.8v7.3h-.7l-4.6-6v6h-.8zm9.3 3.7c0-2 1.5-3.7 3.6-3.7 1.2 0 2 .3 2.7 1l-.5.6c-.6-.5-1.2-.8-2.2-.8-1.6 0-2.7 1.3-2.7 3s1.1 3 2.9 3c.8 0 1.6-.3 2.1-.7v-1.8h-2.2V44h3v2.9c-.7.6-1.7 1.1-2.9 1.1-2.4-.2-3.8-1.9-3.8-3.9m12.6-3.7h.8l3.3 7.3h-.9l-.8-1.9h-3.9l-.9 1.9h-.8l3.2-7.3zm2 4.6l-1.6-3.7-1.7 3.7h3.3zm4.3-.9c0-2 1.5-3.7 3.6-3.7 1.2 0 2 .3 2.7 1l-.5.6c-.6-.5-1.2-.8-2.2-.8-1.6 0-2.7 1.3-2.7 3s1.1 3 2.9 3c.8 0 1.6-.3 2.1-.7v-1.8H44V44h3v2.9c-.7.6-1.7 1.1-2.9 1.1-2.3-.2-3.7-1.9-3.7-3.9m10-3.7h.8v7.3h-.8v-5.4zm4.4 0h.8l4.5 5.8v-5.8h.8v7.3h-.6l-4.7-6v6h-.8zm9.4 3.7c0-2 1.5-3.7 3.6-3.7 1.2 0 2 .3 2.7 1l-.5.5c-.6-.5-1.2-.8-2.2-.8-1.6 0-2.7 1.3-2.7 3s1.1 3 2.9 3c.8 0 1.6-.3 2.1-.7v-1.8h-2.2v-.7h3v2.9c-.7.6-1.7 1.1-2.9 1.1-2.4-.1-3.8-1.8-3.8-3.8M84 40.4h.8l3.3 7.3h-.9l-.8-1.9h-3.9l-.9 1.9h-.8l3.2-7.3zm2 4.6l-1.6-3.7-1.7 3.7H86zm4.6-.4v-4.2h.8v4.1c0 1.6.8 2.4 2.2 2.4 1.3 0 2.2-.8 2.2-2.4v-4.2h.8v4.1c0 2.1-1.2 3.2-3 3.2-1.8.2-3-.9-3-3m9.5-4.2h2.5c2.3 0 3.8 1.6 3.8 3.6s-1.6 3.6-3.8 3.6h-2.5v-7.2zm.8.8v5.7h1.7c1.8 0 3-1.2 3-2.8 0-1.6-1.2-2.9-3-2.9h-1.7zm8.8-.8h.8v7.3h-.8zm4.5 0h5.2v.8H115v2.4h3.9v.8H115v2.5h4.5v.8h-5.3zm8.4 0h.8l4.5 5.8v-5.8h.8v7.3h-.6l-4.7-6v6h-.8zm9.4 3.7c0-2.1 1.5-3.7 3.6-3.7 1.3 0 2.1.5 2.8 1.1l-.6.6c-.6-.6-1.3-1-2.3-1-1.6 0-2.8 1.3-2.8 3s1.2 3 2.8 3c1 0 1.6-.4 2.3-1l.5.5c-.8.8-1.6 1.3-2.9 1.3-1.9-.1-3.4-1.8-3.4-3.8m9.4-3.7h5.2v.8h-4.4v2.4h4v.8h-4v2.5h4.5v.8h-5.3zm8 6.2l.5-.6c.8.7 1.5 1 2.5 1s1.6-.5 1.6-1.2-.4-1-1.9-1.4c-1.7-.4-2.4-.9-2.4-2.1 0-1.1 1-2 2.4-2 1 0 1.8.3 2.5.9l-.5.6c-.7-.5-1.3-.8-2.1-.8-.9 0-1.5.5-1.5 1.2s.4 1.1 2 1.4c1.6.3 2.3.9 2.3 2 0 1.2-1 2-2.5 2-1.1.2-2-.2-2.9-1m-31-30.3h2.9v1.2c1.3-1 2.8-1.5 4.5-1.5 4 0 7.5 3.1 7.5 7v10.4h-2.9v-10c0-2.4-2.1-4.6-4.6-4.6-2.4 0-4.6 1-4.6 4.4v10.1h-2.9v-17zm33.8 13l1.2 2.4c-1.9 1.4-4.4 2.1-6.4 2.1-4.9 0-8.9-3.9-8.9-8.9 0-4.9 3.6-8.8 8.5-8.8 4.8 0 7.9 3.8 7.9 8.3V26h-13.3c.5 2.8 2.9 4.7 5.9 4.7 1.5 0 3.5-.4 5.1-1.4m-11-6v.2h10.2c0-2.1-2.1-4.6-4.9-4.6-2.8 0-4.7 1.9-5.3 4.4"
    />
    <path
      fill="#ffc844"
      d="M100.5 7.4c7.3 0 13.1 5.9 13.1 13.1 0 7.3-5.9 13.1-13.1 13.1-7.3 0-13.1-5.9-13.1-13.1-.1-7.2 5.8-13.1 13.1-13.1m0 23.2c5.6 0 10-4.5 10-10 0-5.6-4.5-10-10-10s-10 4.5-10 10c-.1 5.5 4.4 10 10 10"
    />
    <path
      fill="#303747"
      d="M25.7 10.2c1.2 0 2.3 1.1 2.3 2.3 0 1.3-1.1 2.4-2.3 2.4-1.3 0-2.4-1-2.4-2.4 0-1.2 1-2.3 2.4-2.3m-2.4 6H28v17.2h-4.7V16.2zm11.5.1h4.3v.6c.8-.5 1.9-.9 3.4-.9 2.2 0 4 .6 5.3 1.7 1.3-1.1 3.1-1.7 5.3-1.7 4.8 0 7.6 2.7 7.6 7.6v9.8H56v-9.8c0-1.6-1.3-3-3-3-1.6 0-3 1.2-3 2.8v10h-4.7v-9.8c0-1.6-1.3-3-3-3-1.6 0-2.9 1.2-3 2.8v10h-4.7V16.3zm44.3 11.8l1.9 3.3c-2.3 1.6-4.1 2.3-7 2.3-5.1 0-8.9-3.7-8.9-8.9 0-4.9 3.8-8.8 8.6-8.8 5.1 0 7.9 3.5 7.9 8.4 0 .7 0 1.3-.1 2H70.3c-.1 0-.1.1-.1.2.5 1.7 2.2 2.8 4.3 2.8 1.6 0 3-.5 4.6-1.3m-8-6.9c-.7.7-1 1.5-1 1.7 0 .1 0 .1.1.1h6.5c.1 0 .1 0 .1-.1 0-.5-.2-1.3-.8-1.9-.5-.5-1.3-.9-2.5-.9-.9 0-1.8.5-2.4 1.1"
    />
    <path fill="#ffc844" d="M15.1 7h-1.8l-.5 5.3h1.9zm1.3 0l-.4 5.3h1.4l.9-5.3z" />
    <path fill="#303747" d="M12 7H.9L0 12.3h6s.1 0 .1.1v20.7h5.3V15.5c0-2.1.1-4.2.3-6.3L12 7z" />
  </svg>
);

const TimeoneFooter = (
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path
      fill="#fff"
      d="M9.5 12.7c-.1 0-.2 0-.2.1v-.1h-.2v.9h.2v-.5c0-.2.1-.2.2-.2s.2.1.2.2v.5h.2V13c0-.1-.2-.3-.4-.3m1.5.4c0-.2-.2-.4-.4-.4-.3 0-.5.2-.5.5s.2.5.5.5c.1 0 .2 0 .3-.1l-.1-.1c-.1.1-.2.1-.3.1-.2 0-.3-.1-.3-.3l.8-.2zm-.7 0c0-.1.1-.2.3-.2.2 0 .3.1.3.2h-.6zm-2.2-.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7m0 1.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5c.1.2-.2.5-.5.5m-4.2-.8h.3v.9h-.3zm.2-.3c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1m1.5.3c-.1 0-.2 0-.3.1-.1-.1-.2-.1-.3-.1h-.4v.9h.3v-.5c0-.1.1-.1.2-.1s.2.1.2.2v.5h.3v-.5c0-.1.1-.1.2-.1s.2.1.2.2v.5-.5c0-.5-.2-.6-.4-.6m1.1 0c-.3 0-.5.2-.5.5s.2.5.5.5c.2 0 .3 0 .4-.1l-.1-.3c-.1 0-.2.1-.2.1-.1 0-.2-.1-.2-.2h.6v-.1c-.1-.2-.3-.4-.5-.4m.1.4h-.3s0-.1.1-.1l.1-.1h.1v.2m-4.1-.9v.3H3v1.1h.3v-1.1h.3v-.3h-.9zm4.3-1c-1.5 0-2.8-.6-3.9-1.6-1-1-1.6-2.4-1.6-3.9s.6-2.8 1.6-3.8S5.5.3 7 .3s2.8.6 3.8 1.6 1.6 2.4 1.6 3.8c0 1.5-.6 2.8-1.6 3.9S8.5 11.2 7 11.2zM7 .5C4.1.5 1.7 2.9 1.7 5.7 1.7 8.7 4 11 7 11c2.9 0 5.2-2.4 5.2-5.3C12.3 2.9 9.9.5 7 .5z"
    />
    <path fill="#fff" d="M7.6 9.6V3.9l.1-1.1H5l-.2 1.3h1.4v5.4h1.4z" />
    <path d="M8.4 2.9H8l-.1 1.2h.4zm.8 0h-.5l-.1 1.2H9z" fill="#ffc844" />
  </svg>
);

const TimeoneHeaderBlue = (
  <svg xmlns="http://www.w3.org/2000/svg" width="352" height="353" viewBox="0 0 352 353">
    <g fill="none">
      <path
        fill="#009EB0"
        d="M0.2,175.7 C0.2,274.1 78.4,352.3 176.8,352.3 C273.8,352.3 351.9,274.2 351.9,175.7 C351.9,78.7 273.7,0.6 176.8,0.6 C78.4,0.6 0.2,78.7 0.2,175.7 Z"
      />
      <path
        fill="#FFF"
        d="M194.9 299.9L194.9 128.4C194.9 124.2 195.1 120 195.4 115.9L198.4 80.3 111.4 80.3 104.3 122.2 151.5 122.2C151.8 122.2 152.1 122.5 152.7 123.1 153 123.4 153 123.4 153 123.7L153 300 194.9 300 194.9 299.9zM223 80.2L208.7 80.2 205.2 122.1 219.5 122.1 223 80.2zM247.7 80.2L233.3 80.2 229.8 122.1 240.6 122.1 247.7 80.2z"
      />
    </g>
  </svg>
);

const TimeoneHeader = (
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 364.1 364.2">
    <path
      d="M182.8 7.6C84.4 7.6 6.2 85.7 6.2 182.7c0 98.4 78.2 176.6 176.6 176.6 97 0 175.1-78.1 175.1-176.6 0-97-78.2-175.1-175.1-175.1"
      fill="#303747"
    />
    <path
      d="M200.9 306.9V135.4c0-4.2.2-8.4.5-12.5l3-35.6h-87l-7.1 41.9h47.2c.3 0 .6.3 1.2.9.3.3.3.3.3.6V307h41.9z"
      fill="#fff"
    />
    <path fill="#ffc844" d="M229 87.2h-14.3l-3.5 41.9h14.3zM253.7 87.2h-14.4l-3.5 41.9h10.8z" />
  </svg>
);

const Twitter = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <path
      d="M94.3 272.5c113.4 0 175.4-94 175.4-175.4 0-2.6 0-5.3-.1-7.9 12-8.7 22.5-19.6 30.8-32-11.1 4.9-23 8.2-35.5 9.7 12.7-7.6 22.5-19.7 27.2-34.1-11.9 7.1-25.1 12.1-39.2 14.9-11.3-12-27.3-19.5-45-19.5-34 0-61.7 27.7-61.7 61.7 0 4.8.6 9.5 1.6 14.1-51.2-2.5-96.7-27.2-127.1-64.4-5.3 9.1-8.3 19.7-8.3 31 0 21.4 10.9 40.3 27.4 51.3-10.1-.4-19.6-3.1-27.9-7.7v.8c0 29.8 21.3 54.8 49.4 60.5-5.2 1.4-10.6 2.2-16.2 2.2-4 0-7.8-.4-11.5-1.1 7.8 24.5 30.7 42.3 57.6 42.8C70 236 43.5 245.8 14.6 245.8c-4.9 0-9.9-.2-14.7-.8 27.2 17.3 59.7 27.5 94.4 27.5"
      fill="#fff"
    />
  </svg>
);

export {
  TimeoneComplet as default,
  Applications,
  Dashboard,
  Facebook,
  LeadManagement,
  Linkedin,
  Mobile,
  Nativious,
  PerformanceAdvertiser,
  PerformanceEMailing,
  PerformancePublisher,
  Performance,
  TimeoneComplet,
  TimeoneFooter,
  TimeoneHeaderBlue,
  TimeoneHeader,
  Twitter,
};
